import React from 'react';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';
import { LuSaveAll } from 'react-icons/lu';

import { mainTableWidthRecoil } from '@/recoil/atoms/atoms';
import { softPhoneSaveMessageRecoil } from '@/recoil/atoms/router/mainRouterRecoil';
import { FaSave } from 'react-icons/fa';

const SaveButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => props.theme.colors.txt200};
  border: 2px solid ${(props) => props.theme.colors.txt200};
  border-radius: 0.5rem;
  padding: 1rem 0.4rem;
  white-space: nowrap;
  font-size: 1.4rem;

  &:hover,
  &.active {
    color: ${(props) => props.theme.colors.main};
    border: 2px solid ${(props) => props.theme.colors.main};
  }
`;

const SaveMessageBtn = () => {
  /* 메인 주소록 테이블 width  */
  const [, setMainTableWidth] = useRecoilState(mainTableWidthRecoil);
  const [saveMessage, setSaveMessage] = useRecoilState(softPhoneSaveMessageRecoil);

  const toggleModal = () => {
    const newSaveMessage = saveMessage === false ? true : false;
    setSaveMessage(newSaveMessage);

    const tableWidth = (document.getElementById('mainTable')?.clientWidth ?? 1100) - 450;
    if (newSaveMessage === false) {
      setMainTableWidth(0);
    } else {
      setMainTableWidth(tableWidth);
    }
  };

  return (
    <button className={`${saveMessage ? 'active' : ''}`} onClick={toggleModal} title="문자 저장함">
      <FaSave />
      <div>저장함</div>
    </button>
  );
};

export default SaveMessageBtn;
